/**
 * Alt text for an Instagram thumbnail: the caption's opening words, not the
 * whole post. Hashtags, @mentions and emoji are dropped (screen readers would
 * read them out one by one), whitespace collapsed, and the text cut at a word
 * boundary to at most `max` characters (with «…»). Empty result → `fallback`.
 */
export function shortAlt(caption: string | undefined, fallback: string, max = 125): string {
  const text = (caption ?? '')
    // Only tags/mentions that start a word: an email's «@domain» stays.
    .replace(/(^|[^\p{L}\p{N}_])[#@][\p{L}\p{N}_.]+/gu, '$1 ')
    .replace(/[\p{Extended_Pictographic}\u{FE0F}\u{200D}\u{1F3FB}-\u{1F3FF}]/gu, '')
    .replace(/\s+/g, ' ')
    .trim();
  if (!text) return fallback;
  if (text.length <= max) return text;
  const cut = text.slice(0, max - 1);
  const atWord = cut.lastIndexOf(' ');
  return `${(atWord > max / 2 ? cut.slice(0, atWord) : cut).replace(/[\s.,;:·…-]+$/u, '')}…`;
}
